import { FunctionComponent } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Stack,
    Typography,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useNotification } from '@starjack/features/notifications';
import { Webshop } from '@/models/webshop';
import { useDeleteWebshopMutation } from '@/api/v2/configurations';

type WebshopDeleteDialogProps = {
    webshop: Webshop;
    open: boolean;
    onClose: () => void;
};

export const WebshopDeleteDialog: FunctionComponent<
    WebshopDeleteDialogProps
> = ({ webshop, open, onClose }) => {
    const [deleteHospitality, { isLoading }] = useDeleteWebshopMutation();
    const { addNotification } = useNotification();

    const onRefundTicket = () => {
        deleteHospitality({ webshopId: webshop.id })
            .unwrap()
            .then(() => {
                addNotification({
                    message: 'Webshop erfolgreich gelöscht',
                    type: 'success',
                });
            })
            .catch(() => {
                addNotification({
                    message:
                        'Fehler beim Löschen. Bitte später noch einmal versuchen',
                    type: 'error',
                });
            })
            .finally(() => {
                onClose();
            });
    };

    return (
        <Dialog open={open}>
            <DialogTitle>Webshop löschen</DialogTitle>
            <DialogContent>
                {!!webshop && (
                    <DialogContentText>
                        Soll der Webshop{' '}
                        <Typography sx={{ fontWeight: 600 }} component='span'>
                            {webshop.vanityIdentifier}
                        </Typography>{' '}
                        wirklich gelöscht werden?
                    </DialogContentText>
                )}
            </DialogContent>

            <DialogActions>
                <Stack spacing={2} direction='row'>
                    <Button onClick={onClose}>Abbrechen</Button>
                    <LoadingButton
                        onClick={onRefundTicket}
                        variant='contained'
                        loading={isLoading}
                    >
                        Löschen
                    </LoadingButton>
                </Stack>
            </DialogActions>
        </Dialog>
    );
};
